<template>
  <div class="app-main-inner" style="padding:5px 0;width: fit-content; min-width: 1000px; height: 100%;">
    <div>
      <el-card class="section">
        <fieldset>
          <legend>{{ $t('CargoMsg.Cargo_CargoNature') }}</legend>
          <el-form :disabled="!isEditing" label-width="110px" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_Name')">
              <el-input v-model="form.name" style="width: 300px;" no="1" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PointsToNote')">
              <el-radio-group v-model="form.dangerousChemicals" no="2">
                <el-radio :label="true" no="2_1">{{ $t('CargoMsg.Cargo_Yes') }}</el-radio>
                <el-radio :label="false" no="2_2">{{ $t('CargoMsg.Cargo_No') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_HazmatContained')">
              <el-radio-group v-model="form.special" no="3">
                <el-radio :label="true" no="3_1">{{ $t('CargoMsg.Cargo_Yes') }}</el-radio>
                <el-radio :label="false" no="3_2">{{ $t('CargoMsg.Cargo_No') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AverageMonthlyCargoVolume')">
              <el-row>
                <div style="display: flex;font-size: 12px;">
                  <span>{{ $t('CargoMsg.Cargo_OceanFreight') }}</span>
                  <span style="padding-left: 20px;padding-right: 10px;">FCL</span>
                  <el-input-number
                    :value="form.seaShipmentMonthlyFcl||undefined"
                    :precision="0"
                    controls-position="right"
                    :min="0"
                    :max="999999999999"
                    no="4"
                    @input="val=>{form.seaShipmentMonthlyFcl=val}"
                  />
                  <span style="padding-left: 10px;padding-right: 20px;">TEU</span>

                  <span style="padding-right: 10px;">LCL</span>
                  <el-input-number
                    :value="form.seaShipmentMonthlyLcl||undefined"
                    :precision="0"
                    controls-position="right"
                    :min="0"
                    :max="999999999999"
                    no="5"
                    @input="val=>{form.seaShipmentMonthlyLcl=val}"
                  />
                  <span style="padding-left: 10px;">CBM</span>
                </div>
              </el-row>
              <el-row>
                <div style="display: flex; padding-top: 10px; font-size: 12px;">
                  <span style="padding-right: 20px;">{{ $t('CargoMsg.Cargo_Air') }}</span>
                  <el-input-number
                    :value="form.airlineShipmentMonthlyMt||undefined"
                    :precision="0"
                    :conttrols-right="true"
                    controls-position="right"
                    :min="0"
                    :max="999999999999"
                    no="6"
                    @input="val=>{form.airlineShipmentMonthlyMt=val}"
                  />
                  <span style="padding-left: 10px;">MT</span>
                </div>
              </el-row>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PeakSeason')">
              <el-row>
                <div style="display: flex;padding-left: 15px;">
                  <el-checkbox v-model="formDetail.peakSeason1" style="margin-left: -15px;" no="7">{{ $t('CargoMsg.Cargo_January') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason2" no="8">{{ $t('CargoMsg.Cargo_February') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason3" no="9">{{ $t('CargoMsg.Cargo_March') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason4" no="10">{{ $t('CargoMsg.Cargo_April') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason5" no="11">{{ $t('CargoMsg.Cargo_May') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason6" no="12">{{ $t('CargoMsg.Cargo_June') }}</el-checkbox>
                </div>
              </el-row>
              <el-row>
                <div style="display: flex;padding-left: 15px;">
                  <el-checkbox v-model="formDetail.peakSeason7" style="margin-left: -15px;" no="13">{{ $t('CargoMsg.Cargo_July') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason8" no="14">{{ $t('CargoMsg.Cargo_August') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason9" no="15">{{ $t('CargoMsg.Cargo_September') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason10" no="16">{{ $t('CargoMsg.Cargo_October') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason11" style="margin-left: -7px;" no="17">{{ $t('CargoMsg.Cargo_November') }}</el-checkbox>
                  <el-checkbox v-model="formDetail.peakSeason12" style="margin-left: -5.5px;" no="18">{{ $t('CargoMsg.Cargo_December') }}</el-checkbox>
                </div>
              </el-row>
            </el-form-item>
          </el-form>
        </fieldset>
      </el-card>
      <el-card class="section">
        <fieldset>
          <legend>{{ $t('CargoMsg.Cargo_MainLineTransport') }}</legend>
          <el-form :disabled="!isEditing" label-width="110px" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredShippingMethod')">
              <el-checkbox v-model="formDetail.chkSeaWay" no="19">{{ $t('CargoMsg.Cargo_OceanFreight') }}</el-checkbox>
              <el-checkbox v-model="formDetail.chkAirWay" no="20">{{ $t('CargoMsg.Cargo_Air') }}</el-checkbox>
              <el-checkbox v-model="formDetail.chkRailWay" no="21">{{ $t('CargoMsg.Cargo_Railway') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredShippingRoute')">
              <cargo-advance-select
                :select-type="basicCacheKeys.basic_data_Region"
                :custom-label="(item)=>`${item.code}[${item.name}]`"
                :show-custom-label-in-option="true"
                :multiple="true"
                callback-method-type="value"
                :default-multiple-value="formDetail.regionCodes"
                tag-value="code"
                tag-name="name"
                style="width: 500px;"
                filterable
                :filter-tag-names="['code','name']"
                no="22"
                @parentCallBack="value=>formDetail.regionCodes=[...value]"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredPortSea')">
              <cargo-advance-select
                :select-type="basicCacheKeys.basic_data_Seaport"
                callback-method-type="value"
                :multiple="true"
                :default-multiple-value="formDetail.seaPortCodes"
                tag-value="code"
                tag-name="englishName"
                style="width: 500px;"
                filterable
                :filter-tag-names="['englishName']"
                no="23"
                @parentCallBack="value=>formDetail.seaPortCodes=[...value]"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredAirportAir')">
              <cargo-advance-select
                :select-type="basicCacheKeys.basic_data_Airport"
                filterable
                callback-method-type="value"
                :multiple="true"
                :default-multiple-value="formDetail.airPortCodes"
                tag-value="code"
                tag-name="englishName"
                style="width: 500px;"
                :filter-tag-names="['code','englishName']"
                no="24"
                @parentCallBack="value=>formDetail.airPortCodes=[...value]"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CommonlyUsedTradeTerms')">
              <el-checkbox-group v-model="incoTermCodes" style="width: 1200px;" no="25" @change="handlerincoTermCodes">
                <el-checkbox v-for="item in incoTerms" :key="item.code" :label="item.code" no="26">
                  {{ (isZh ? item.localName : item.name) || item.code }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredOceanCarrier')">
              <cargo-advance-select
                :select-type="basicCacheKeys.basic_data_Company"
                :method-params="{seaCmp:true,active:true}"
                :custom-label="(item)=>`${item.chineseName}`"
                :show-custom-label-in-option="true"
                :multiple="true"
                :default-multiple-value="formDetail.shippingCompanyCodes"
                tag-value="cmpIdx"
                tag-name="chineseName"
                style="width: 500px;"
                filterable
                :filter-tag-names="['chineseName','englishName']"
                no="27"
                @parentCallBack="item=>formDetail.shippingCompanyCodes=[...item.value]"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredAirline')">
              <cargo-advance-select
                :select-type="basicCacheKeys.basic_data_Company"
                :method-params="{airCmp:true,active:true}"
                :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                :show-custom-label-in-option="true"
                :multiple="true"
                :default-multiple-value="formDetail.airlineCompanyCodes"
                tag-value="cmpIdx"
                tag-name="chineseName"
                style="width: 500px;"
                filterable
                :filter-tag-names="['shortName','chineseName','englishName']"
                no="28"
                @parentCallBack="item=>formDetail.airlineCompanyCodes=[...item.value]"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredShippingTerms')">
              <el-checkbox-group v-model="shipperTermCodes" style="width: 1200px;" no="29" @change="handlerShipperTermCodes">
                <el-checkbox v-for="item in shippingTerms" :key="item.code" :label="item.code" no="30">
                  {{ (!item.localName) ? (!item.name ? item.code : item.name) : item.localName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </fieldset>
      </el-card>
      <el-card class="section">
        <fieldset>
          <legend>{{ $t('CargoMsg.Cargo_MainLineTransport') }}</legend>
          <el-form :disabled="!isEditing" label-width="110px" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredCustomsBroker')">
              <div style="display: flex;">
                <el-radio-group v-model="form.customsBrokerType" no="31">
                  <div style="display: flex;width: 200px;padding-top: 7px;">
                    <el-radio :label="$t('SeaExport.SelfDeclaration')" no="32">{{ $t('CargoMsg.Cargo_SelfDeclaration') }}</el-radio>
                    <el-radio :label="$t('CargoMsg.Cargo_PoaCustomsDeclaration')" no="33">{{ $t('CargoMsg.Cargo_PoaCustomsDeclaration') }}</el-radio>
                  </div>
                </el-radio-group>
                <cargo-advance-select
                  :select-type="basicCacheKeys.basic_data_Company"
                  :data-filter-function="customsBrokerFilter"
                  :custom-label="customsBrokerLabel"
                  :show-custom-label-in-option="true"
                  filterable
                  style="width: 400px;padding-left: 30px;"
                  :default-value="form.customsBrokerId||''"
                  :method-params="{customsBroker:true,bookingAgent:true,active:true}"
                  no="34"
                  @parentCallBack="p=>{form.customsBrokerId=p.value}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredTruckingService')">
              <div style="display: flex;">
                <el-radio-group v-model="form.truckingType" no="35">
                  <div style="display: flex;width: 200px;padding-top: 7px;">
                    <el-radio :label="$t('CargoMsg.Cargo_SelfDelivery')" no="36">{{ $t('CargoMsg.Cargo_SelfDelivery') }}</el-radio>
                    <el-radio :label="$t('CargoMsg.Cargo_LoadingAtFactory')" no="37">{{ $t('CargoMsg.Cargo_LoadingAtFactory') }}</el-radio>
                  </div>
                </el-radio-group>
                <cargo-company-select
                  :method-params="{truckCmp:true,active:true}"
                  :default-value="form.truckingInfoId||''"
                  style="width: 400px;padding-left: 30px;"
                  no="38"
                  @change="p=>{form.truckingInfoId=p.value}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PreferredAgentAtDestination')">
              <cargo-advance-select
                :select-type="basicCacheKeys.basic_data_Company"
                :method-params="{overseaAgent:true,active:true}"
                :default-value="form.overSeaAgentId||''"
                filterable
                style="width: 500px;"
                :headers="[$t('Partners.englishName')]"
                :fields="['englishName']"
                tag-name="englishName"
                no="39"
                @parentCallBack="p=>{form.overSeaAgentId=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_IssueHbl')">
              <el-radio-group v-model="form.signedHbl" no="40">
                <el-radio :label="true" no="41">{{ $t('CargoMsg.Cargo_Yes') }}</el-radio>
                <el-radio :label="false" no="42">{{ $t('CargoMsg.Cargo_No') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DocReleaseAgainstPayment')">
              <el-radio-group v-model="form.payed" no="43">
                <el-radio :label="true" no="44">{{ $t('CargoMsg.Cargo_Yes') }}</el-radio>
                <el-radio :label="false" no="45">{{ $t('CargoMsg.Cargo_No') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
              <el-input v-model="form.remarks" type="textarea" :rows="4" style="width: 500px;" no="46" />
            </el-form-item>
          </el-form>
        </fieldset>
      </el-card>
    </div>
  </div>
</template>

<script>

import { QuotationClient } from '@/class/model/sales/QuotationClient'
import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'TabCrmCustomerBussiness',
  components: {
    cargoAdvanceSelect, cargoCompanySelect
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      basicCacheKeys,
      CrmCustomerConstants,
      quotationClient: new QuotationClient().fillDefaultValue().getData(),
      incoTerms: [],
      shippingTerms: [],
      form: {}, // 业务特性
      initForm: { // 初始化业务特性
        uuid: '',
        name: '',
        special: false,
        dangerousChemicals: false,
        seaShipmentMonthlyFcl: 0,
        seaShipmentMonthlyLcl: 0,
        airlineShipmentMonthlyMt: 0,
        customsBrokerType: '',
        customsBrokerId: 0,
        truckingType: '',
        truckingInfoId: 0,
        signedHbl: false,
        payed: false,
        remarks: '',
        overSeaAgentId: 0,
        type: '',
        quotationClientUuid: '',
        quotationClientBusinessMultipleDetail: []
      },
      formDetail: {}, // 业务特性详情
      initFormDetail: { // 初始化业务特性详情
        uuid: '',
        bType: '',
        bValue: '',
        quotationClientBusinessUuid: '',
        // 以下是扩展属性
        peakSeason1: '',
        peakSeason2: '',
        peakSeason3: '',
        peakSeason4: '',
        peakSeason5: '',
        peakSeason6: '',
        peakSeason7: '',
        peakSeason8: '',
        peakSeason9: '',
        peakSeason10: '',
        peakSeason11: '',
        peakSeason12: '',
        chkSeaWay: false,
        chkAirWay: false,
        chkRailWay: false,
        incoTermCodes: [], // 贸易条款
        shipperTermCodes: [], // 运输条款
        regionCodes: [], // 航线
        seaPortCodes: [], // 海港
        airPortCodes: [], // 空港
        shippingCompanyCodes: [], // 船公司
        airlineCompanyCodes: [] // 航空公司
      },
      incoTermCodes: [], // 临时存放复选框组结果
      shipperTermCodes: [] // 临时存放复选框组结果
    }
  },
  computed: {
    isEditing() {
      return this.action !== 'look'
    }
  },
  watch: {
  },
  created() {
    this.shippingTerms = getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm) || []
    this.incoTerms = getCacheListByKey(basicCacheKeys.basic_data_IncoTerm) || []
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh && this.isEditing) return
      this.quotationClient = { ...row }
      this.loading = getLoading()
      if (!this.isEditing || !this.quotationClient.quotationClientBusiness) {
        this.quotationClient.quotationClientBusiness = null
        await new QuotationClient(this.quotationClient).loadQuotationClientRelated({ business: true })
      }
      if (!this.quotationClient.quotationClientBusiness) this.quotationClient.quotationClientBusiness = { ...this.initForm }
      console.log('this.quotationClient.quotationClientBusiness', this.quotationClient.quotationClientBusiness)
      this.form = this.quotationClient.quotationClientBusiness
      this.loadQuotationClientBusinessMultipleDetailHandler()
      console.log('this.formDetail', this.formDetail)
      this.loading.close()
    },
    // 加载业务特性详情
    loadQuotationClientBusinessMultipleDetailHandler() {
      let details = this.form.quotationClientBusinessMultipleDetail
      // this.$logger.log('details======', details)
      if (!details || details.length <= 0) {
        details = []
        this.formDetail = { ...this.initFormDetail }
        return
      }
      const regionCodes = []
      const seaPortCodes = []
      const airPortCodes = []
      const shippingCompanyCodes = []
      const airlineCompanyCodes = []
      const incoTermCodes = []
      const shipperTermCodes = []
      for (const detail of details) {
        if (!detail.bType || !detail.bValue) continue
        // 业务旺季
        if (detail.bType === CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code) {
          switch (detail.bValue) {
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_JAN.code :
              this.formDetail.peakSeason1 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_FEB.code :
              this.formDetail.peakSeason2 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_MAR.code :
              this.formDetail.peakSeason3 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_APR.code :
              this.formDetail.peakSeason4 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_MAY.code :
              this.formDetail.peakSeason5 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_JUNE.code :
              this.formDetail.peakSeason6 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_JULY.code :
              this.formDetail.peakSeason7 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_AUG.code :
              this.formDetail.peakSeason8 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_SEPT.code :
              this.formDetail.peakSeason9 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_OCT.code :
              this.formDetail.peakSeason10 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_NOV.code :
              this.formDetail.peakSeason11 = true
              break
            case CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_DEC.code :
              this.formDetail.peakSeason12 = true
              break
            default :
              break
          }
        }

        // 偏好走货类型
        if (detail.bType === CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T2.code) {
          switch (detail.bValue) {
            case CrmCustomerConstants.WAY_SEA.code :
              this.formDetail.chkSeaWay = true
              break
            case CrmCustomerConstants.WAY_AIR.code :
              this.formDetail.chkAirWay = true
              break
            case CrmCustomerConstants.WAY_RAIL.code :
              this.formDetail.chkRailWay = true
              break
            default :
              break
          }
        }

        // 偏好航线
        if (detail.bType === CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T3.code) {
          const reg = getObjectByCache(basicCacheKeys.basic_data_Region, 'code', detail.bValue)
          if (reg) regionCodes.push(reg.code)
        }

        // 偏好港口(海港)
        if (detail.bType === CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T4.code) {
          const reg = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', detail.bValue)
          if (reg) seaPortCodes.push(reg.code)
        }

        // 偏好港口(空港)
        if (detail.bType === CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T5.code) {
          const reg = getObjectByCache(basicCacheKeys.basic_data_Airport, 'code', detail.bValue)
          if (reg) airPortCodes.push(reg.code)
        }

        // 常用贸易条款
        if (detail.bType === CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T6.code) {
          const item = getObjectByCache(basicCacheKeys.basic_data_IncoTerm, 'code', detail.bValue)
          if (item) incoTermCodes.push(item.code)
        }

        // 偏好船公司
        if (detail.bType === CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T7.code) {
          const cmp = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', parseInt(detail.bValue))
          if (cmp) shippingCompanyCodes.push(cmp.cmpIdx)
        }

        // 偏好航空公司
        if (detail.bType === CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T8.code) {
          const cmp2 = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', parseInt(detail.bValue))
          if (cmp2) airlineCompanyCodes.push(cmp2.cmpIdx)
        }

        // 偏好运输条款
        if (detail.bType === CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T9.code) {
          const item = getObjectByCache(basicCacheKeys.basic_data_ShippingTerm, 'code', detail.bValue)
          if (item) shipperTermCodes.push(item.code)
        }
      }
      this.incoTermCodes = this.formDetail.incoTermCodes = incoTermCodes || []
      this.shipperTermCodes = this.formDetail.shipperTermCodes = shipperTermCodes || []
      this.formDetail.regionCodes = regionCodes || []
      this.formDetail.seaPortCodes = seaPortCodes || []
      this.formDetail.airPortCodes = airPortCodes || []
      this.formDetail.shippingCompanyCodes = shippingCompanyCodes || []
      this.formDetail.airlineCompanyCodes = airlineCompanyCodes || []
    },
    endTabHandler() {
      const multipleDetail = []
      this.fillMultipleDetail(multipleDetail)
      this.form.quotationClientBusinessMultipleDetail = multipleDetail
    },
    // 保存
    getSubmitData() {
      this.endTabHandler()
      this.$logger.log('quotationClientBusiness====', this.form)
      return {
        quotationClientBusiness: this.form
      }
    },
    // 业务特性详情
    fillMultipleDetail(multipleDetail) {
      let detail = null
      if (this.formDetail.peakSeason1) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'Jan'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason2) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'Feb'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason3) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'Mar'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason4) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'Apr'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason5) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'May'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason6) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'June'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason7) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'July'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason8) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'Aug'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason9) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'Sept'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason10) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'Oct'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason11) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'Nov'
        multipleDetail.push(detail)
      }
      if (this.formDetail.peakSeason12) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T1.code)
        detail.bValue = 'Dec'
        multipleDetail.push(detail)
      }
      // 偏好走货类型
      if (this.formDetail.chkSeaWay) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T2.code)
        detail.bValue = '海运'
        multipleDetail.push(detail)
      }
      if (this.formDetail.chkAirWay) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T2.code)
        detail.bValue = this.$t('CargoMsg.Cargo_Air')
        multipleDetail.push(detail)
      }
      if (this.formDetail.chkRailWay) {
        detail = {}
        detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T2.code)
        detail.bValue = this.$t('CargoMsg.Cargo_Railway')
        multipleDetail.push(detail)
      }

      // 偏好航线
      if (this.formDetail.regionCodes && this.formDetail.regionCodes.length > 0) {
        for (const key in this.formDetail.regionCodes) {
          detail = {}
          detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T3.code)
          detail.bValue = this.formDetail.regionCodes[key]
          multipleDetail.push(detail)
        }
      }

      // 偏好港口(海港)
      if (this.formDetail.seaPortCodes && this.formDetail.seaPortCodes.length > 0) {
        for (const key in this.formDetail.seaPortCodes) {
          detail = {}
          detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T4.code)
          detail.bValue = this.formDetail.seaPortCodes[key]
          multipleDetail.push(detail)
        }
      }

      // 偏好港口(空港)
      if (this.formDetail.airPortCodes && this.formDetail.airPortCodes.length > 0) {
        for (const key in this.formDetail.airPortCodes) {
          detail = {}
          detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T5.code)
          detail.bValue = this.formDetail.airPortCodes[key]
          multipleDetail.push(detail)
        }
      }

      // 常用贸易条款
      if (this.formDetail.incoTermCodes && this.formDetail.incoTermCodes.length > 0) {
        for (const key in this.formDetail.incoTermCodes) {
          detail = {}
          detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T6.code)
          detail.bValue = this.formDetail.incoTermCodes[key]
          multipleDetail.push(detail)
        }
      }

      // 偏好船公司
      if (this.formDetail.shippingCompanyCodes && this.formDetail.shippingCompanyCodes.length > 0) {
        for (const key in this.formDetail.shippingCompanyCodes) {
          detail = {}
          detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T7.code)
          detail.bValue = this.formDetail.shippingCompanyCodes[key]
          multipleDetail.push(detail)
        }
      }

      // 偏好航空公司
      if (this.formDetail.airlineCompanyCodes && this.formDetail.airlineCompanyCodes.length > 0) {
        for (const key in this.formDetail.airlineCompanyCodes) {
          detail = {}
          detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T8.code)
          detail.bValue = this.formDetail.airlineCompanyCodes[key]
          multipleDetail.push(detail)
        }
      }

      // 偏好运输条款
      if (this.formDetail.shipperTermCodes && this.formDetail.shipperTermCodes.length > 0) {
        for (const key in this.formDetail.shipperTermCodes) {
          detail = {}
          detail.bType = parseInt(CrmCustomerConstants.CUSTOMER_CLIENTBUSINESS_T9.code)
          detail.bValue = this.formDetail.shipperTermCodes[key]
          multipleDetail.push(detail)
        }
      }
    },
    clearFrom() {
      this.form = { ...this.initForm }
      this.formDetail = { ...this.initFormDetail }
    },
    // 偏好报关行
    customsBrokerLabel(data) {
      if (data) {
        const name = this.$store.getters.language === 'zh' ? data.chineseName : data.englishName
        return name + '[' + data.shortName + ']'
      }
      return ''
    },
    // 过滤报关行
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.bookingAgent && item.active
    },
    // 处理复选框组选中值
    handlerincoTermCodes(val) {
      this.formDetail.incoTermCodes = val
    },
    handlerShipperTermCodes(val) {
      this.formDetail.shipperTermCodes = val
    }
  }
}
</script>

<style scoped>
</style>
